import { Base } from "./body.base";
import { Content } from "./components/content";
import { Link } from "./components/link";

export const Body = Object.assign(Base, {
    Content: Content,
    Link: Link
});
